import styled, { css } from 'styled-components';
import { shade } from 'polished';

interface ButtonProps {
  disabled?: boolean;
}

export const Container = styled.button<ButtonProps>`
  background: #008FC3;
  height: 56px;
  border-radius: 10px;
  border: 0;
  padding: 0 16px;
  color: #fff;
  width: 100%;
  font-weight: 500;
  margin-top: 16px;
  transform: background-color 0.2s;

  ${props =>
    props.disabled &&
    css`
      background: ${shade(0.2, '#008FC3')};
    `};

  &:hover {
    background: ${shade(0.2, '#008FC3')};
  }
`;
